export const apiGetUserInfo = userId => `/api/account/info/${userId}/`;
export const apiGetUserSession = "/api/account/info/my/";
export const apiAccountTokenAuth = "/api/account/token_auth/";
export const apiAccountOtcToken = "/api/account/otc_token/";
export const apiAccountOtcTokenResend = "/api/account/resend_otc/";
export const apiGetProfile = userId => `/api/account/profile/${userId}/`;